import { render, staticRenderFns } from "./single-overview.vue?vue&type=template&id=4a3f5d0b&scoped=true&"
import script from "./single-overview.vue?vue&type=script&lang=js&"
export * from "./single-overview.vue?vue&type=script&lang=js&"
import style0 from "./single-overview.vue?vue&type=style&index=0&id=4a3f5d0b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3f5d0b",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiTagline: require('/app/components/ui/tagline.vue').default,UiIcon: require('/app/components/ui/icon.vue').default})
